import ky from 'ky/umd'

const API = ky.extend({ prefixUrl: '/dashboard-api/' })

export default API
